/*
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-03-15 16:37:33
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2023-10-13 15:16:34
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/api/workBenchApi.js
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
 */
import http from "@/utils/http";
export function getMiniData(headers, data) {
  const config = {
    method: "POST",
    url: `/user/platform/report/mp`,
    headers,
    data,
  };
  return http(config);
}

export function getPlatformData(headers, data) {
  const config = {
    method: "POST",
    url: `/user/platform/report/md`,
    headers,
    data,
  };
  return http(config);
}

// 获取所有会议内容
export function getPlatformAllMeet(headers, params) {
  const config = {
    method: "GET",
    url: `/user/platform/report/getMeetingList`,
    headers,
    params,
  };
  return http(config);
}

// 获取广告统计接口
export function getAdvertReport(headers, advertisingCode) {
  const config = {
    method: "GET",
    url: `/user/advertising/click/report?advertisingCode=${advertisingCode}`,
    headers,
  };
  return http(config);
}
